import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import * as Sentry from "@sentry/react";

/* global document, Office, module, require, HTMLElement */

// Initialize Sentry
Sentry.init({
    dsn: "https://622e04d59f18d59967723ed11e994a2a@diag.prom4apps.com/93",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],

    tracesSampleRate: 1,

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,

    environment: process.env.NODE_ENV,
    release: process.env.VERSION,
});

/* global document, Office, module, require, HTMLElement */
const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
    root?.render(
        <Sentry.ErrorBoundary
            fallback={<div>An error has occurred</div>}
            showDialog
        >
            <App />
        </Sentry.ErrorBoundary>
    );
});

if ((module as any).hot) {
    (module as any).hot.accept("./components/App", () => {
        const NextApp = require("./components/App").default;
        root?.render(NextApp);
    });
}